import React, { useState } from "react";
import * as Flex from "../../../styles/v2/toyota/globals/Flex";
import * as Status from "./styles/StatusStyles";

export type StatusEntryType = {
    title?: string;
    description?: string;
    value?: string;
    collapsibleContent?: any; // Will be stringified
    values?: ({
        onClick?: () => void;
        label: string;
        value?: string | boolean | null;
        long?: boolean; // makes the value field full width
        link?: boolean; // renders a "Click here" link with the value as href
        collapsibleContent?: any; // Will be stringified
    } | null)[]; // Added null to easily support optional values.
    noBottomLineSpace?: boolean;
};

const StatusModalEntry = (props: { entry: StatusEntryType }): JSX.Element => {
    const { entry } = props;

    return (
        <div>
            {!!(entry.title || entry.description) && (
                <Flex.Row>
                    <Flex.Col mb={2}>
                        {entry.title && <h3>{entry.title}</h3>}
                        {entry.description && (
                            <small>
                                <b>{entry.description}</b>
                            </small>
                        )}
                    </Flex.Col>
                </Flex.Row>
            )}
            {entry.values &&
                entry.values.map((value, index) => {
                    if (value === null) return null;

                    if (value.collapsibleContent) {
                        return (
                            <StatusModalCollapsibleRow
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                label={value.label}
                                content={value.collapsibleContent}
                            />
                        );
                    }

                    if (value.onClick) {
                        return (
                            <StatusModalButtonRow
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                label={value.label}
                                value={value.value as string}
                                onClick={value.onClick}
                            />
                        );
                    }

                    return (
                        <Status.Row key={value.label}>
                            {value.long ? (
                                <Flex.Col>
                                    <div>{value.label}</div>
                                    <div>{value.value && typeof value.value !== "undefined" ? value.value : "n/a"}</div>
                                </Flex.Col>
                            ) : (
                                <>
                                    <Flex.Col width={5 / 12}>{value.label}</Flex.Col>
                                    <Flex.Col width={7 / 12}>
                                        {typeof value.value !== "undefined" ? (
                                            value.link ? (
                                                <a href={value.value?.toString()}>Click here</a>
                                            ) : (
                                                String(value.value)
                                            )
                                        ) : (
                                            "undefined"
                                        )}
                                    </Flex.Col>
                                </>
                            )}
                        </Status.Row>
                    );
                })}
            {entry.collapsibleContent && (
                <StatusModalCollapsibleRow label={entry.value} content={entry.collapsibleContent} />
            )}
            {entry.value && !entry.collapsibleContent && (
                <Status.Row>
                    <Flex.Col>{entry.value.toString()}</Flex.Col>
                </Status.Row>
            )}

            {!entry.noBottomLineSpace && <br />}
        </div>
    );
};

type StatusModalCollapsibleRowProps = { content: string; label?: string };
const StatusModalCollapsibleRow = ({ label, content }: StatusModalCollapsibleRowProps): JSX.Element => {
    const [collapsed, setCollapsed] = useState<boolean>(true);

    return (
        <Status.Row>
            <Flex.Col onClick={() => setCollapsed(!collapsed)}>
                {label && `${label.toString()} - `}
                {collapsed ? "Click to open" : "Click to close"}
            </Flex.Col>
            {!!content && !collapsed && (
                <Flex.Col width={1}>
                    <Status.Code>{content.toString()}</Status.Code>
                </Flex.Col>
            )}
        </Status.Row>
    );
};

type StatusModalButtonProps = { onClick: () => void; value: string; label: string };
const StatusModalButtonRow = ({ onClick, value, label }: StatusModalButtonProps): JSX.Element => {
    return (
        <Status.Row>
            <Flex.Col width={5 / 12}>{label}</Flex.Col>
            <Flex.Col width={7 / 12}>
                <button type="button" onClick={onClick}>
                    {value}
                </button>
            </Flex.Col>
        </Status.Row>
    );
};

export default StatusModalEntry;
